var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import "./dialog.css";
var defaultOptions = {
    autoOpen: false,
    autoFocus: "input,button,textarea",
    closeOnOverlayClick: true,
    modal: true,
    closeOnEscape: true
};
var JSLDialog = /** @class */ (function () {
    function JSLDialog(el, options) {
        var _this = this;
        this.options = options;
        this.overlay = el;
        this.el = el.firstElementChild;
        if (this.options.closeOnOverlayClick) {
            this.overlay.addEventListener("mousedown", function (evt) {
                if (evt.target === _this.overlay) {
                    _this.close();
                }
            });
            this.overlay.addEventListener("touchstart", function (evt) {
                if (evt.target === _this.overlay) {
                    _this.close();
                }
            });
        }
    }
    JSLDialog.prototype.open = function (modal) {
        var _this = this;
        if ((modal !== undefined && !modal) || !this.options.modal) {
            this.overlay.style.background = "transparent";
            this.overlay.style.pointerEvents = "none";
        }
        this.overlay.style.display = "block";
        var $footer = this.el.querySelector(".dlg-footer");
        var $body = this.el.querySelector(".dlg-body");
        if ($footer != null && $body != null) {
            // TODO ?
        }
        if (this.options.autoFocus) {
            setTimeout(function () {
                var firstInput = _this.el.querySelector(_this.options.autoFocus);
                if (firstInput != null) {
                    firstInput.focus();
                }
            }, 0);
        }
        if (this.options.closeOnEscape || this.options.OkOnEnter) {
            this.onKeydownEvent = function (args) {
                var _a;
                if (args.keyCode === 27 && _this.options.closeOnEscape) { // escape
                    _this.close();
                }
                else if (args.keyCode === 13 && _this.options.OkOnEnter) { // ok
                    var ok_btn = _this.el.querySelector(".dlg-ok-btn");
                    if (ok_btn != null) {
                        (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.blur();
                        ok_btn.click();
                    }
                }
            };
            document.addEventListener("keydown", this.onKeydownEvent);
        }
        if (this.options.onOpen) {
            this.options.onOpen();
        }
    };
    JSLDialog.prototype.close = function () {
        if (this.options.onClose) {
            if (this.options.onClose() === false) {
                return;
            }
        }
        this.overlay.style.display = "none";
        if (this.onKeydownEvent != null) {
            document.removeEventListener("keydown", this.onKeydownEvent);
        }
    };
    JSLDialog.prototype.getOverlay = function () {
        return this.overlay;
    };
    return JSLDialog;
}());
export { JSLDialog };
export function Dialog(input, options) {
    var o = __assign(__assign({}, defaultOptions), options);
    var el;
    if (typeof input === "string") {
        el = document.querySelector(input);
    }
    else {
        el = input;
    }
    var result = new JSLDialog(el, o);
    if (!o.autoOpen) {
        el.style.display = "none";
    }
    else {
        result.open();
    }
    return result;
}
